export default __webpack_public_path__ + "static/media/clock.ea7d9592.svg";